import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R14};
  background-color: ${Color.Grey100};
`

interface ItemWrapperProps {
  isOutlined: boolean
  hasFooterContent: boolean
}

export const ItemWrapper = styled.div<ItemWrapperProps>`
  padding: ${({ isOutlined }) => (isOutlined ? Spacing.S12 : Spacing.S8)}
    ${({ hasFooterContent }) => (hasFooterContent ? Spacing.S8 : 0)} ${Spacing.S8} ${Spacing.S8};
  border: 1px solid ${({ isOutlined }) => (isOutlined ? Color.Grey200 : 'transparent')};

  ${({ isOutlined }) => isOutlined && `border-radius: ${BorderRadius.R12};`};

  ${({ isOutlined }) =>
    !isOutlined &&
    `
    &:hover {
      background-color: ${Color.Grey100};
    }
  `}
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: ${Spacing.S12};
  min-width: 0;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`
